export default "__VITE_ASSET__YSmhUPbf__"